import React from 'react';
import { Box, CircularProgress, IconButton, Menu } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { ICallLangMenuProps } from './types';
import LangFlag from '../../../shared/LangFlag/LangFlag';
import { CallLangMenuListHOC } from '../hocs/CallLangMenuListHOC';
import { Wording } from '../../Call/wording';

export function CallLangMenu({
	langCode,
	langTitle,
	isUnsupported,
}: ICallLangMenuProps) {

	const [langsEl, setLangsEl] = React.useState<null | HTMLElement>(null);
	const langsOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		setLangsEl(event.currentTarget);
	};
	const langsClose = () => {
		setLangsEl(null);
	};

	// the new language shows only once the server has saved it
	const [isSaving, setSaving] = React.useState(false);
	const onSaving = (saving: Promise<void>) => {
		setSaving(true);
		saving
			.catch((e) => console.error('failed to save the call language', e))
			.finally(() => setSaving(false));
	};

	return (
		<>
			<IconButton
				className={'call-lang-menu'}
				sx={{
					height: theme.spacing(5),
					backgroundColor: theme.palette.grey[50],
					borderRadius: theme.spacing(0.75),

					'.lang-flag': {
						width: 1,
					},

					'.lang-flag__title': {
						fontSize: theme.typography.subtitle2,
						color: theme.palette.grey[900],
						fontWeight: 600,
					},
				}}
				disabled={isSaving}
				onClick={langsOpen}
			>
				{isSaving
					? <CircularProgress size={theme.spacing(2.5)} />
					: <LangFlag
						code={langCode}
						langTitle={langTitle}
					/>
				}
			</IconButton>

			{isUnsupported &&
				<Box
					sx={{
						mt: theme.spacing(1),
						fontSize: theme.typography.subtitle1,
						color: theme.palette.grey[600],
					}}
				>
					{Wording.LANG_UNSUPPORTED}
				</Box>
			}

			<Menu
				anchorEl={langsEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				open={!!langsEl}
				onClose={langsClose}
				sx={{
					'.MuiPaper-root': {
						width: theme.spacing(30),
						background: 'transparent',
						boxShadow: 'none',
					},
					'.MuiList-root': {
						p: 0,
					},
				}}
			>
				{!!langsEl &&
					<CallLangMenuListHOC
						onClose={langsClose}
						onSaving={onSaving}
					/>
				}
			</Menu>
		</>
	);
};
